import { Button } from '@shared/components/shadcn';
import { ROUTES } from '@shared/utils';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

function JoinButton() {
  const t = useTranslations('lotteries.results.kiosk');

  return (
    <Button asChild variant="accent" data-track-name="Register">
      <Link href={ROUTES.REGISTER}>{t('join_button')}</Link>
    </Button>
  );
}

export { JoinButton };
